module.exports = "/assets/20df4fc8667028b77cca78394378e8da.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/MR.png
// module id = 1624
// module chunks = 0